import { CircularProgress } from "@mui/joy";

export function LoadingScreen() {
    return (
        <div className="flex justify-center items-center h-full">
            <CircularProgress />
        </div>
    );
}